<template>
  <Modal
    :id="'cmp-royalty-royalty_accounts-delete_statement_modal'"
    @cancelled="onCancel"
  >
    <template slot="header">warning</template>

    <template slot="body">
      <div v-if="invoiceInfo && invoiceInfo.data" class="dt-modal--body">
        <span>
          Are you sure you want to delete the statement -
          {{ selectedStatement.royalty_account_name }}</span
        >

        <div class="count-content">
          <span>Invoice No: {{ invoiceInfo.data.invoice_ref }} </span>
          <span>Invoice Date: {{ invoiceInfo.data.invoice_date }} </span>
          <span>Invoice Status: {{ invoiceInfo.derived.status }} </span>
        </div>
        <span></span>
      </div>
    </template>

    <template slot="options">
      <div class="dt-modal--options">
        <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
        <button class="dt-button v1 s6" @click.stop="onOkClick">Ok</button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import * as ActionTypes from "../../store/types";
import { clone } from 'ramda';

export default {
  components: {
    Modal,
    InputField,
  },
  props: ["selectedStatement", "selectedAccountDetails", "invoiceInfo"],
  data() {
    return {};
  },
  mixins: [],
  mounted() {
    // this.countRoyaltyPeriodPayment();
  },
  computed: {
    royalty_period_id: function () {
      return this.$route.query.royalty_period_id;
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    countRoyaltyPeriodPayment: function () {
      AccountsService.countRoyaltyPeriodPayment(
        this.selectedStatement?.royalty_period_id
      ).then((res) => {
        AccountsService.royaltyPeriodInvoiceInfo(
          this.selectedStatement?.royalty_period_id
        ).then((res) => {
          this.invoiceInfo = res.data.invoice;
        });
      });
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onOkClick: async function () {
      
      const selectedStatement = clone(this.selectedStatement);

      const statements = this.selectedAccountDetails?.statement_data.filter(
        (b) => b.royalty_period_id !== selectedStatement.royalty_period_id
      );

      this[ActionTypes.RoyaltyAccountsStatements.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        statement_data: [...statements] || [],
      });

      const res = await AccountsService.removeRoyaltyPeriod(selectedStatement);
      
      this.onCancel();
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-delete_statement_modal {
  .dt-modal--header {
    margin: 0 0 20px;
  }

  .dt-modal--body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span {
      font-weight: 400;
    }
    .header-warning {
      color: var(--text-accent);
      font-size: 15px;
    }
    .count-content {
      display: flex;
      flex-direction: column;
      padding: 20px;
    }
  }
  .dt-modal--options {
    margin-top: 10px;
  }
}
</style>
